import { urlForgotPassword, urlCreateUser, urlUpdatePassword, urlUpdateTel, urlUpdateEmail } from "./urls"

export const messagesForgot = {
    type : 'forgotPassword',
    url : urlForgotPassword,
    messageTextsOK : {
        messageTitle : 'Revise su email y sigas las instrucciones',
        buttonLeft : '',
        buttonRight: 'Volver al login'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        buttonLeft : 'Continuar',
        buttonRight: ''
    }
}
export const messagesCreateUser = {
    type : 'createUser',
    url : urlCreateUser,
    messageTextsOK : {
        messageTitle : 'Usuario creado y enviado al email del empleado',
        buttonLeft : '',
        buttonRight: 'Continuar'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        buttonLeft : 'Continuar',
        buttonRight: ''
    }
}
export const messagesEditUser = {
    type : 'createUser',
    url : urlCreateUser,
    messageTextsOK : {
        messageTitle : 'Usuario editado con éxito',
        buttonLeft : '',
        buttonRight: 'Continuar'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        buttonLeft : 'Continuar',
        buttonRight: ''
    }
}

export const saveNewPassword = {
    type : 'saveNewPassword',
    url : urlUpdatePassword,
    messageTextsOK : {
        messageTitle : 'Contraseña Guardada correctamente',
        buttonLeft : '',
        buttonRight: 'Continuar'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        buttonLeft : 'Continuar',
        buttonRight: ''
    }
}

export const saveNewTel = {
    type : 'saveNewTel',
    url : urlUpdateTel,
    messageTextsOK : {
        messageTitle : 'Teléfono cambiado correctamente',
        buttonLeft : '',
        buttonRight: 'Continuar'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        buttonLeft : 'Continuar',
        buttonRight: ''
    }
}

export const saveNewEmail = {
    type : 'saveNewEmail',
    url : urlUpdateEmail,
    messageTextsOK : {
        messageTitle : 'Email cambiado. Debe loguearse con el nuevo email',
        buttonLeft : '',
        buttonRight: 'Continuar'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        buttonLeft : 'Continuar',
        buttonRight: ''
    }
}